import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AngularProgressStepsComponent } from './angular-progress-steps.component';


@NgModule({
    imports: [CommonModule],
    declarations: [AngularProgressStepsComponent],
    exports: [AngularProgressStepsComponent],
    providers: []
})
export class AngularProgressStepsModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/progress-steps/angular-progress-steps.module.ts